<template>
  <div id="GoTop">
    <div @mouseover="curs = 2" @mouseleave="curs = 0" style="width: 55px;height: 55px;background: #333;margin-bottom: 2px"><i style="color: white" class="iconfont">&#xe646;</i>
      <div class="zx" v-if="curs === 2" @mouseover="curs = 2" @mouseleave="curs = 0" style="background:white;width:180px;height:55px;position: absolute;left: -172px;box-shadow: rgba(0, 0, 0, .1) 0 0 5px;"><i class="iconfont" style="color: black">&#xe8bd;</i>4001-786-176</div>
    </div>
    <div @click="$router.push('/contactus')" style="width: 55px;height: 55px;background: #333;margin-bottom: 2px"><i style="color: white" class="iconfont">&#xe643;</i></div>
    <div @click="openNewPage" style="width: 55px;height: 55px;background: #333;margin-bottom: 2px"><i style="color: white" class="iconfont">&#xe645;</i></div>
    <div @mouseover="curs = 1" @mouseleave="curs = 0" style="width: 55px;height: 55px;background: #333;margin-bottom: 2px"><i style="color: white" class="iconfont">&#xe641;</i>
      <img v-if="curs === 1" src="../assets/spec/wm.jpg" alt="" style="position: absolute;left: -138px;width: 140px;height: 140px">
    </div>
    <span class="glyphicon glyphicon-chevron-up" @click="GoTop()"></span>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
      curs:0,
    };
  },
  methods: {
    GoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    openNewPage(){
      const url = 'https://j.map.baidu.com/ad/92ri';
      window.open(url, '_blank');
    },
  }
};
</script>
<style scoped>
#GoTop {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 20px;
  bottom: 770px;
  z-index: 99999999;
  cursor: pointer;
}
#GoTop > span {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 55px;
  height: 55px;
  background: #333;
  margin-bottom: 2px;
  color: white;
  font-size: 1.8rem;
}
#GoTop {
  display: block;
  position: fixed;
  top: 45%;
  right: 50px;
  padding: 10px;
}

#GoTop div {
  margin-bottom: 8px !important;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

#GoTop div span {
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  top: 25px;
  right: 62px;
  border-left: #ddd 10px solid;
  border-top: 10px transparent solid;
  border-bottom: 10px transparent solid;
}

#GoTop div i {
  color: white;
  font-size: 1.8rem;
}

@media screen and (max-width: 768px){
  #GoTop{
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue